const config = {
  apiBaseUrl: import.meta.env.REACT_APP_API_BASEURL,
  aktosEnv: import.meta.env.REACT_APP_AKTOS_ENV,
  sentryDsn: import.meta.env.REACT_APP_SENTRY_DSN,
};
export default config;
